// extracted by mini-css-extract-plugin
module.exports = {"responsiveContainer":"layout_responsiveContainer__6ZMAI","responsiveContainerFlushTop":"layout_responsiveContainerFlushTop__WaMql"};